import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type SideMenuState = {
	sideMenu: {
		isOpenOnDesktopView: boolean;
		isOpenOnMobileView: boolean;
		isTeamSwitcherAsideOpen: boolean;
		shouldRenderSideMenu: boolean;
	};
};

type SideMenuActions = {
	openSideMenuOnDesktopView: (isOpenOnDesktopView: SideMenuState['sideMenu']['isOpenOnDesktopView']) => void;
	openSideMenuOnMobileView: (isOpenOnMobileView: SideMenuState['sideMenu']['isOpenOnMobileView']) => void;
	setIsOpenTeamSwitcherAside: (isTeamSwitcherAsideOpen: SideMenuState['sideMenu']['isTeamSwitcherAsideOpen']) => void;
	setShouldRenderSideMenu: (shouldRenderSideMenu: SideMenuState['sideMenu']['shouldRenderSideMenu']) => void;
};

export type SideMenuSlice = SideMenuState & SideMenuActions;

const sideMenuInitialState: SideMenuState = {
	sideMenu: {
		isOpenOnDesktopView: true,
		isOpenOnMobileView: false,
		isTeamSwitcherAsideOpen: false,
		shouldRenderSideMenu: false,
	},
};

export function sideMenuSlice(set: NamedSet<ZustandStore>): SideMenuSlice {
	return {
		...sideMenuInitialState,
		openSideMenuOnDesktopView(isOpenOnDesktopView: SideMenuState['sideMenu']['isOpenOnDesktopView']): void {
			set(
				(state: SideMenuState) => {
					state.sideMenu.isOpenOnDesktopView = isOpenOnDesktopView;
					state.sideMenu.isOpenOnMobileView = false;
					return state;
				},
				false,
				'[openSideMenuOnDesktopView]',
			);
		},
		openSideMenuOnMobileView(isOpenOnMobileView: SideMenuState['sideMenu']['isOpenOnDesktopView']): void {
			set(
				(state: SideMenuState) => {
					state.sideMenu.isOpenOnMobileView = isOpenOnMobileView;
					state.sideMenu.isOpenOnDesktopView = false;
					return state;
				},
				false,
				'[openSideMenuOnMobileView]',
			);
		},
		setIsOpenTeamSwitcherAside(isTeamSwitcherAsideOpen: SideMenuState['sideMenu']['isTeamSwitcherAsideOpen']): void {
			set(
				(state: SideMenuState) => {
					state.sideMenu.isTeamSwitcherAsideOpen = isTeamSwitcherAsideOpen;
					return state;
				},
				false,
				'[setIsOpenTeamSwitcherAside]',
			);
		},
		setShouldRenderSideMenu(shouldRenderSideMenu: SideMenuState['sideMenu']['shouldRenderSideMenu']): void {
			set(
				(state: SideMenuState) => {
					state.sideMenu.shouldRenderSideMenu = shouldRenderSideMenu;
					return state;
				},
				false,
				'[setShouldRenderSideMenu]',
			);
		},
	};
}
